import { Component, computed, input, output, PipeTransform } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { CustomDropDownArrowDirective } from 'ok-angular-shared/directives';

interface EnumDisplayItem<T> {
  value: T;
  displayText: string;
}

@Component({
  selector: 'adm-admin-enum-select-list',
  imports: [MatFormFieldModule, MatSelectModule, MatIconModule, CustomDropDownArrowDirective],
  templateUrl: './admin-enum-select-list.component.html',
  styleUrl: './admin-enum-select-list.component.scss',
})
export class AdminEnumSelectListComponent<T> {
  label = input.required<string>();
  enumChanged = output<T | null>();
  initialValue = input<T | null>(null);
  enumObject = input.required<T[]>();
  translatePipe = input<PipeTransform | null>(null);
  disabled = input<boolean>(false);

  enumDisplayItems = computed<EnumDisplayItem<T>[]>(() => {
    const enumValues = this.enumObject();
    const pipe = this.translatePipe();
    return enumValues.map(value => {
      const displayText = pipe ? pipe.transform(value) : String(value);
      return { value, displayText };
    });
  });

  clearInput(): void {
    this.enumChanged.emit(null);
  }
}
